import type {
  FieldError,
  FieldId,
  ValueId,
} from '@snap-types/models/auto-configurator/state';

import { getField } from '../../logic/field';
import { getValue } from '../../logic/value';
import { WritableAutoConfiguratorState } from '../slice';
import { validateFieldValue } from './validate-field-value';

export function applyValidation(
  state: WritableAutoConfiguratorState,
  fieldId: FieldId,
  valueId: ValueId,
  existingErrors: FieldError[] = [],
  includeCustomValidators = true,
) {
  const field = getField(state, fieldId);
  const valueObject = getValue(state, valueId);

  valueObject.errors = [
    ...existingErrors,
    ...validateFieldValue({
      state,
      fieldId,
      valueId,
      field,
      value: valueObject,
      includeCustomValidators,
    }),
  ];
  valueObject.isValid = valueObject.errors.length === 0;
}

export function revalidateFieldValuePreservingParseErrors(
  state: WritableAutoConfiguratorState,
  fieldId: FieldId,
  valueId: ValueId,
) {
  const valueObject = getValue(state, valueId);

  if (valueObject.hasParseError) {
    return;
  }

  applyValidation(state, fieldId, valueId);
}
